// Components
import Container from '../Container';
import Navbar from '../Navbar';
// Utils
import { currentYear } from '../../utils/getYearsFilters';
// Images
import logoAquinas from '../../Images/logo/logo_Aquinas.png';
import logoOnlineLibrary from '../../Images/logo/logo_OlibBlack.svg';
// Styles
import './Footer.css';
// Translate
import { useTranslation } from 'react-i18next';

const Footer = ({ allContent = true }) => {
  const { t } = useTranslation();
  return (
    <footer>
      {allContent && (
        <Container className='footerContainer'>
          <img src={logoOnlineLibrary} alt='logo Aquinas Network' />
          <Navbar type='black' />
        </Container>
      )}

      <section className='rightsSection'>
        <Container className='rightsSectionContainer flex flex-col md:flex-row py-3 gap-2'>
          <p className='text-center'>
            {t('All rights reserved')} <b>Aquinas Online Library {currentYear} ®</b>
          </p>
          <div>
            <p>{t('Powered by')}</p>
            <img src={logoAquinas} alt='logo Aquinas Network' />
          </div>
        </Container>
      </section>
    </footer>
  );
};

export default Footer;
